export const PATHS = {
    DRIVERS: '/drivers',
    REQUESTS: '/orders',
    BOOKINGS: '/bookings',
};
